import PageTitle from 'client/common/components/page-title';

export default PageTitle;
